import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../land/assets/img/marche.png'


const _hoisted_1 = {
  id: "hero",
  class: "hero section dark-background"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gy-4" }
const _hoisted_4 = {
  class: "col-lg-8 d-flex flex-column justify-content-center align-items text-center text-md-start",
  "data-aos": "fade-up"
}
const _hoisted_5 = { class: "d-flex mt-4 justify-content-center justify-content-md-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "col-lg-4 order-lg-last hero-img",
          "data-aos": "zoom-out"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Phone 1",
            class: "phone-1"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Nos marchés modernes sont désormais à votre service.", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, " Obtenez en toute transparence la place qu'il vous faut dans nos marchés.", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "download-btn lien",
              to: "/e-processus"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "bi bi-credit-card" }, null, -1),
                _createElementVNode("span", null, "Procéder au paiement", -1)
              ])),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}